// extracted by mini-css-extract-plugin
module.exports = {"header":"header--1w262","svg":"svg--2T4sL"};